module.exports = __webpack_public_path__ + "img/graph_icon.c40014db.svg";